import { Breadcrumb } from '../../common/types/api/v4/boats/search';
import getCategoryKeyById from '../../common/utils/getCategoryKeyById';
import { categoryDictionary } from './extractCategoryAndLocationSlugs';

type Context = 'category-worldwide' | 'category-area' | 'location' | 'category-location' | 'generic-worldwide' | 'generic-area';
type LocationReviewTitleArgs = {
  context: Context;
  category?: string;
  location?: string;
};

const getLocationReviewTitleTranslation = (
  locationSlug: string,
  categorySlug: string,
  breadcrumbs: Breadcrumb[],
  hasGeometry: boolean,
): LocationReviewTitleArgs => {
  let context: Context;
  const category = getCategoryKeyById(categoryDictionary.get(categorySlug)?.id);
  const location = breadcrumbs.length > 0 && breadcrumbs[breadcrumbs.length - 1].name;

  if (categorySlug && locationSlug) {
    context = 'category-location';
  } else if (categorySlug) {
    context = hasGeometry ? 'category-area' : 'category-worldwide';
  } else if (locationSlug) {
    context = 'location';
  } else {
    context = hasGeometry ? 'generic-area' : 'generic-worldwide';
  }

  return {
    context,
    category,
    location,
  };
};

export default getLocationReviewTitleTranslation;
